import React, { useEffect, useRef, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import CSS from "csstype";

import dialogContents from "./DialogContent";
import { closeDialog } from "../../store/actions";
import { setPositionToViewPort } from "../../lib/elementUtilities";

interface IProps {
  name: string,
  header?: string,
  subHeader?: string;
  classes?: string[];
  elementRef?: any;
  event?: any;
}

const mapDispatchToProps = (dispatch: any) => ({
  closeDialog: () => dispatch(closeDialog())
});

const connector = connect(null, mapDispatchToProps);

type ReduxProps = ConnectedProps<typeof connector>;

const Dialog = (props: IProps & ReduxProps) => {
  const DialogContent = dialogContents[props.name];
  const divRef = useRef<HTMLDivElement>(null);

  const [style, setStyle] = useState<CSS.Properties<string | number>>({ display: "block" });

  useEffect(() => {
    console.log("using effect ...");
    const body = document.querySelector("body");
    if (body && body.clientWidth > 767) {
      let position: CSS.Properties<number> = {};

      if (props.elementRef && props.elementRef.getBoundingClientRect().width) {
        position.left = props.elementRef.getBoundingClientRect().left
          - ((divRef.current ? divRef.current.getBoundingClientRect().width : 0)
            - props.elementRef.getBoundingClientRect().width) / 2;
        position.top = props.elementRef.getBoundingClientRect().bottom;
      } else if (props.event) {
        position.left = props.event.clientX
          - (divRef.current ? divRef.current.getBoundingClientRect().width : 0) / 2;
        position.top = props.event.clientY;
      }

      if (divRef.current) {
        position = setPositionToViewPort(divRef.current, position);
      }

      setStyle({
        ...style,
        ...position
      })
    }
  }, [props.name]);

  return (
    <div className={`dialog ${props.classes?.join(" ")}`} style={style} ref={divRef}>
      {props.header
      && <header className="dialog-header">
        <h2 className="title multiline white">
          {props.header}
          {props.subHeader && <><br /><small>{props.subHeader}</small></>}
        </h2>
        <a
          className="dialog-dismiss"
          onClick={props.closeDialog}
        >
          ×
        </a>
      </header>}
      <DialogContent {...props}/>
    </div>
  )
}

export default connector(Dialog);
